import { EthereumProvider } from "@walletconnect/ethereum-provider";
import { CHAIN } from "./format";

// Public WalletConnect v2 client identifier (safe to ship in the browser).
const WC_PROJECT_ID =
  process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || "dc07f2192374242b07adb70fa5d5903c";

// Public RPC the connected wallet uses to reach Blokista Chain (chainId 90909).
const WC_RPC_URL = process.env.REACT_APP_WC_RPC_URL || "https://rpc.bccscan.org";

let wcProvider = null;
let wcInitPromise = null;

export async function getWalletConnectProvider() {
  if (wcProvider) return wcProvider;
  if (!wcInitPromise) {
    wcInitPromise = EthereumProvider.init({
      projectId: WC_PROJECT_ID,
      optionalChains: [CHAIN.chainId],
      rpcMap: { [CHAIN.chainId]: WC_RPC_URL },
      showQrModal: true,
      metadata: {
        name: "Blokista Explorer",
        description: "Blokista Chain block explorer",
        url: typeof window !== "undefined" ? window.location.origin : "https://bccscan.org",
        icons: [
          (typeof window !== "undefined" ? window.location.origin : "https://bccscan.org") +
            "/blokista-logo.webp",
        ],
      },
      methods: ["eth_sendTransaction", "personal_sign", "eth_signTypedData_v4"],
      events: ["chainChanged", "accountsChanged"],
    });
  }
  wcProvider = await wcInitPromise;
  return wcProvider;
}

export async function disconnectWalletConnect() {
  try {
    if (wcProvider && wcProvider.session) await wcProvider.disconnect();
  } catch { /* ignore */ }
  wcProvider = null;
  wcInitPromise = null;
}
